import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

import axios from 'axios';
import './interceptors/axios';

import { store } from './Redux/store';
import { Provider } from 'react-redux';

import { DarkModeProvider, useDarkMode } from './Components/CoreApp/context/DarkModeContext';
import ThemeProvider from './Components/CoreApp/theme/index';

import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

// 1. Set the default base URL for relative requests (e.g., axios.post('/login'))
axios.defaults.baseURL = window.location.hostname === 'localhost' 
  ? 'http://localhost:4000/api' 
  : 'https://ipms.insollex.com/api';

// 2. Intercept and silently rewrite hardcoded production URLs during local testing
axios.interceptors.request.use((config) => {
  if (window.location.hostname === 'localhost' && typeof config.url === 'string') {
    config.url = config.url.replace('https://ipms.insollex.com/api', 'http://localhost:4000/api');
  }
  return config;
});

// 3. Intercept and silently rewrite Native Fetch requests during local testing
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;
  if (window.location.hostname === 'localhost') {
    if (typeof resource === 'string') {
      resource = resource.replace('https://ipms.insollex.com/api', 'http://localhost:4000/api');
    } else if (resource instanceof URL) {
      resource = new URL(resource.toString().replace('https://ipms.insollex.com/api', 'http://localhost:4000/api'));
    } else if (resource instanceof Request) {
      const newUrl = resource.url.replace('https://ipms.insollex.com/api', 'http://localhost:4000/api');
      resource = new Request(newUrl, resource);
    }
  }
  return originalFetch(resource, config);
};


// Wrapper to read darkMode from context and pass as prop to ThemeProvider
function Main() {
  const { darkMode } = useDarkMode();

  return (
    <ThemeProvider darkMode={darkMode}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <DarkModeProvider>
        {/* Use Main so that useDarkMode hook works */}
        <Main />
      </DarkModeProvider>
    </Provider>
  </HelmetProvider>
);

serviceWorker.unregister();
reportWebVitals();
